const BetOfferDefault = {
  title: 'Example JSON',
  expectedOutput: 'Full Time',
  initialDisplayedCode: `{
    "outcomeId": 2950948554,
    "betOffer": {
      "id": 2385752319,
      "betOfferType": {
        "id": 10,`,
  moreCode: `
        "name": "Match"
      },
      "criterion": {
      "label": "Full Time"
    },
    "outcomes": [
      { 
        "id": 2950948551
      },{
        "id": 2950948554
      }
    ]},
    "event": {
      "id": 1018562026,
      "tags": ["BET_BUILDER", "MATCH"]
  }
}`,
};

export default BetOfferDefault;
